<h2 mat-dialog-title class="title-color">Global Rewards Portal Says...</h2>
<mat-dialog-content>
{{data.message}}    
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>